import { makeStyles } from '@material-ui/styles';

export default makeStyles(() => ({

    st0: {
        fill: '#FFFFFF',
    },

    st2: {
        fontSize: '16px',
        fontWeight: '500',
    },

    st3: {
        clipPath: 'url(#SVGID_2_)',
    },

}));
